import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-umbrella-close",
  "use": "icon-si-glyph-umbrella-close-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-umbrella-close\" id=\"icon-si-glyph-umbrella-close\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1077</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M10.031,10.938 L10.031,11.983 L10.969,11.983 L7.907,1.968 L7.907,0.43 C7.907,0.202 7.722,0.019 7.495,0.019 C7.266,0.019 7.083,0.203 7.083,0.43 L7.083,1.968 L3.985,11.983 L4.938,11.983 L4.938,10.938 L6.016,10.938 L6.016,11.983 L7.032,11.983 L7.032,15.532 C7.032,15.76 7.283,15.944 7.511,15.944 C7.739,15.944 7.97,15.759 7.97,15.532 L7.97,11.983 L8.939,11.983 L8.939,10.938 L10.031,10.938 L10.031,10.938 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-umbrella-close.svg
// module id = Vgu+
// module chunks = 62